import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { ISummaryReportOptions } from '../util/DataModelInterface';

const parseOptionValues = (o: any) => {
  const option = o as ISummaryReportOptions;
  option.coolContainerMonthlyCost = parseFloat(o.coolContainerMonthlyCost);
  option.ldaOpenContainerMonthlyCost = parseFloat(o.ldaOpenContainerMonthlyCost);
  option.sdaCeCrtContainerMonthlyCost = parseFloat(o.sdaCeCrtContainerMonthlyCost);
  option.receivedMonthlyCostPerKilo = parseFloat(o.receivedMonthlyCostPerKilo);
  return option;
}

export const getSummaryReportOptions = async () => {
  let summaryReportOptions = [];
  const url = `${getFunctionBaseUrl()}/api/summaryReportOptions`;
  const response: any[] = await rest.get(url);
  summaryReportOptions = response.map(parseOptionValues);
  return summaryReportOptions;
}

export const saveSummaryReportOptions = async (options: ISummaryReportOptions) => {
  const url = `${getFunctionBaseUrl()}/api/summaryReportOptions`;
  const response = await rest.post(url, options);
  return response;
}